import { render, staticRenderFns } from "./wheeled-luggage.vue?vue&type=template&id=65b9e081&scoped=true&"
var script = {}
import style0 from "./wheeled-luggage.vue?vue&type=style&index=0&id=65b9e081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b9e081",
  null
  
)

export default component.exports